import React from 'react';
import { Accordion } from './Accordion';
const faqs = [{
  q: '¿Cómo recibo el material después de comprar?',
  a: 'Inmediatamente después de confirmar el pago recibís un email con el link de descarga de todos los PDFs. Acceso en menos de 5 minutos desde cualquier dispositivo.'
}, {
  q: '¿Sirve para instructoras con poca experiencia o solo para las avanzadas?',
  a: 'Está diseñado para todos los niveles. El Tomo 1 arranca desde los fundamentos y cada tomo tiene progresiones graduales. Tanto si empezás como si tenés años de experiencia vas a encontrar material que te sirve desde el primer día.'
}, {
  q: '¿Es editable? ¿Puedo modificarlo?',
  a: 'Los PDFs están en formato lectura para preservar el diseño y la estructura. Podés imprimirlos, guardarlos en tu dispositivo y usarlos como referencia en cada clase.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. Los 6 bonos estratégicos están incluidos en ambas opciones sin costo adicional. El Pack Élite agrega los 2 upsell exclusivos: Coreografías Completas y Academia Rentable.'
}, {
  q: '¿Sirve si doy clases individuales o solo para grupos?',
  a: 'Sirve para ambos formatos. Las progresiones y sesiones están pensadas tanto para clases grupales como para el trabajo individual con alumnas.'
}, {
  q: '¿Sirve si tengo alumnas de distintas edades al mismo tiempo?',
  a: 'Sí. Cada ejercicio y sesión incluye variaciones por nivel de dificultad para que puedas trabajar con grupos heterogéneos sin que la clase se convierta en un caos.'
}, {
  q: '¿Qué diferencia tiene con otros materiales de gimnasia rítmica?',
  a: 'Es el único sistema en español diseñado específicamente para instructoras argentinas que incluye los 5 aparatos oficiales, planificación anual completa, gestión de academia y recursos para padres en un solo producto.'
}, {
  q: '¿Por qué elegir el Pack Élite y no el estándar?',
  a: 'Si además de enseñar querés tener coreografías listas para exhibiciones y las herramientas para hacer crecer tu academia como negocio, el Pack Élite es la opción más completa y la más elegida.'
}, {
  q: '¿Tiene garantía real?',
  a: 'Sí. 7 días de garantía total. Si por cualquier motivo no es lo que esperabas te devolvemos el 100% del dinero sin preguntas ni formularios.'
}];
export function FAQ() {
  return <section className="py-10 md:py-20 bg-white" data-id="element-99">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-100">
        <div className="text-center mb-6 md:mb-12" data-id="element-101">
          <h2 className="text-2xl md:text-5xl font-bold font-serif text-secondary-dark mb-2 md:mb-4" data-id="element-102">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-2.5 md:space-y-4" data-id="element-103">
          {faqs.map((faq, index) => <Accordion key={index} title={<h3 className="text-sm md:text-lg font-bold text-gray-900" data-id="element-105">
                  {faq.q}
                </h3>} className="border-gray-200" data-id="element-104">
              <p className="text-sm md:text-base text-gray-700 leading-relaxed pt-1 md:pt-2" data-id="element-106">
                {faq.a}
              </p>
            </Accordion>)}
        </div>
      </div>
    </section>;
}